import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/constants/testIds";

const quotes = [
  {
    quote:
      "Vertex modernized eight elevators across our downtown portfolio without missing a single service commitment to our tenants. Their mechanics know these buildings better than we do.",
    name: "Danielle Nguyen",
    role: "VP Operations, Bay Heritage REIT",
  },
  {
    quote:
      "We called at 2:14 AM on a Sunday during a February storm. A Vertex mechanic was on-site by 3:11 AM. That's the difference — they actually mean 24/7.",
    name: "Marco Bianchi",
    role: "Property Manager, Etobicoke Towers",
  },
  {
    quote:
      "For a heritage building on Queen West, we needed a contractor who understood both code and character. Vertex delivered both — the cab interiors are stunning.",
    name: "Aisha Rahman",
    role: "Principal, Rahman + Partners Architects",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid={TESTIMONIALS.root}
      className="border-b border-[#E5E5E5] py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16">
          <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-[#FF5E00] mb-4">
            Trusted By GTA Property Owners
          </div>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-3xl">
            Reliability, said out loud.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border border-[#E5E5E5]">
          {quotes.map((q, i) => (
            <motion.blockquote
              key={q.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.1, duration: 0.55 }}
              className={`p-8 md:p-10 flex flex-col ${
                i !== 0 ? "md:border-l" : ""
              } ${i > 0 && i < 3 ? "border-t md:border-t-0" : ""} border-[#E5E5E5]`}
            >
              <Quote size={28} className="text-[#FF5E00] mb-6" strokeWidth={1.5} />
              <p className="font-display font-medium text-lg md:text-xl leading-snug tracking-tight text-[#0A0A0A] flex-1">
                “{q.quote}”
              </p>
              <footer className="mt-8 pt-6 border-t border-[#E5E5E5]">
                <div className="font-bold text-sm text-[#0A0A0A]">{q.name}</div>
                <div className="text-xs text-[#525252] mt-1">{q.role}</div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
